import { Outlet } from "react-router";
import { Card, CardContent } from "../../components/ui/card";

export const ErrorLayout = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100 p-4">
      <Card className="max-w-md w-full shadow-lg">
        <CardContent className="pt-6">
          <Outlet />
        </CardContent>
      </Card>
    </div>
  );
};

export default ErrorLayout;
